import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect, useState } from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
import CustomControlMoneyEditTextField from "../../unit/forms/CustomControlMoneyEditTextField";

const PaymentMethodField = () => {
  return <>Payment Method xxxxxxxxx</>;
};

export default function CustomApprovedFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const { appId, record } = props;
  const loan = record?.loan;
  const btnName = props.btnName ? props.btnName : "Approve";
  let defaultShowTermData = [];
  if (record.sSubType != "account") {
    defaultShowTermData = [
      "rate",
      "term",
      "note_date",
      "first_payment_date",
      "payment_frequency",
      "number_payments",
      "maturity_date",
    ];
  } else {
    defaultShowTermData = ["account_service"];
  }
  const [showTermData, setShowTermData] =
    useState<string[]>(defaultShowTermData);

  const [maturityDate, setMaturityDate] = useState("");
  const [paymentCount, setPaymentCount] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [checkCal, setCheckCal] = useState(true);

  let defaultNoteDate = record?.dNoteDate;
  if (
    defaultNoteDate == "0000-00-00 00:00:00" ||
    defaultNoteDate == null ||
    defaultNoteDate == undefined
  ) {
    defaultNoteDate = dayjs().format("YYYY-MM-DD");
  } else {
    defaultNoteDate = dayjs(record?.dNoteDate).format("YYYY-MM-DD");
  }
  const [noteDate, setNoteDate] = useState(defaultNoteDate);
  let defaultFirstPaymentDate = record?.dFirstPaymentDate;
  if (
    defaultFirstPaymentDate == "0000-00-00 00:00:00" ||
    defaultFirstPaymentDate == null ||
    defaultFirstPaymentDate == undefined
  ) {
    defaultFirstPaymentDate = dayjs().format("YYYY-MM-DD");
  } else {
    defaultFirstPaymentDate = dayjs(record?.dFirstPaymentDate).format(
      "YYYY-MM-DD"
    );
  }
  const [firstPaymentDate, setFirstPaymentDate] = useState(
    defaultFirstPaymentDate
  );
  const [paymentFrequency, setPaymentFrequency] = useState(
    record?.sPaymentFrequency ||
      (Array.isArray(record?.paymentFrequencyData) &&
      record.paymentFrequencyData.length > 0
        ? record.paymentFrequencyData[0].bbkey
        : "")
  );
  const normalizeRateValue = (value: any) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    return String(value);
  };
  let defaultRate = record?.rateRecommendation;
  if (record?.loan && record?.loan?.interestRate) {
    defaultRate = record?.loan?.interestRate;
  }
  const [interestRate, setInterestRate] = useState(
    normalizeRateValue(defaultRate ?? "0.00")
  );
  let defaultTerm = record?.termSubmit;
  if (record?.termRecommendation) {
    defaultTerm = record?.termRecommendation;
  }
  if (record?.termReview) {
    defaultTerm = record?.termReview;
  }
  // if (record?.loan && record?.loan?.noteTerm) {
  //   defaultTerm = record?.loan?.noteTerm;
  // }
  const [terms, setTerms] = useState<any>(parseInt(defaultTerm));
  const [loanAmount, setLoanAmount] = useState<any>(record?.amountSubmit);
  const [interestRateError, setInterestRateError] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [noteDateError, setNoteDateError] = useState(false);
  const [firstPaymentDateError, setFirstPaymentDateError] = useState(false);
  const [paymentFrequencyError, setPaymentFrequencyError] = useState(false);
  const [numberPaymentsError, setNumberPaymentsError] = useState(false);
  const [maturityDateError, setMaturityDateError] = useState(false);
  const refresh = useRefresh();
  useEffect(() => {
    calMatDate();
  }, [noteDate, firstPaymentDate, paymentFrequency, interestRate, terms]);

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    if (name === "loanamount") {
      setLoanAmount(value);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  const formatRate = (num: any) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };

  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      //查找数组中是否已经存在了，如果存在了就不添加了
      defautRateOptionList.push({
        label: formatRate(record?.rateData[i]),
        value:
          record?.rateData[i] == undefined
            ? "0.00"
            : normalizeRateValue(record?.rateData[i]),
      });
    }
  }
  const defautTermsList: { label: any; value: any }[] = [];
  defautTermsList.push({ label: "Select", value: "" });
  if (record.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: record.termsData[i],
      });
    }
  }

  const defautPaymentFreqList: { label: any; value: any }[] = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }

  const calMatDate = async () => {
    let checkCalFun = true;
    const dialog = document.getElementById(
      `dialog-application-approved-${appId}`
    );
    const interest_rate = interestRate;
    if (
      interest_rate === "" ||
      interest_rate == null ||
      interest_rate == undefined
    ) {
      if (dialog) {
        const input = dialog.querySelector(
          '[name="interest_rate"]'
        ) as HTMLElement;
        if (input) input.style.backgroundColor = "#fffac7";
      }
      checkCalFun = false;
    }

    if (terms == "" || terms == null || terms == undefined) {
      if (dialog) {
        const input2 = dialog.querySelector('[name="terms"]') as HTMLElement;
        if (input2) input2.style.backgroundColor = "#fffac7";
      }
      checkCalFun = false;
    }

    let note_date = noteDate;
    if (
      note_date == "" ||
      note_date == null ||
      note_date == undefined ||
      note_date == "YYYY-MM-DD"
    ) {
      if (dialog) {
        const input3 = dialog.querySelector(
          '[name="note_date"]'
        ) as HTMLElement;
        if (input3) input3.style.backgroundColor = "#fffac7";
      }
      checkCalFun = false;
    }

    let first_payment_date = firstPaymentDate;
    if (
      first_payment_date == "" ||
      first_payment_date == null ||
      first_payment_date == undefined ||
      first_payment_date == "YYYY-MM-DD"
    ) {
      if (dialog) {
        const input4 = dialog.querySelector(
          '[name="first_payment_date"]'
        ) as HTMLElement;
        if (input4) input4.style.backgroundColor = "#fffac7";
      }
      checkCalFun = false;
    }

    if (dayjs(first_payment_date).isBefore(dayjs(), "day")) {
      errorNotify("First Payment Date must be greater than today");
      return false;
    }
    if (dayjs(first_payment_date).isBefore(dayjs(note_date), "day")) {
      errorNotify("First Payment Date must be greater than Note Date");
      return false;
    }
    const payment_frequency = paymentFrequency;
    if (
      payment_frequency == "" ||
      payment_frequency == null ||
      payment_frequency == undefined
    ) {
      if (dialog) {
        const input5 = dialog.querySelector(
          '[name="payment_frequency"]'
        ) as HTMLElement;
        if (input5) input5.style.backgroundColor = "#fffac7";
      }
      checkCalFun = false;
    }

    const formJson = {
      amount: loanAmount || record.amountSubmit,
      note_date: note_date,
      term: terms,
      iterm: terms,
      payment_frequency: payment_frequency,
      rate: interest_rate,
      first_payment_date: first_payment_date,
    };

    if (checkCalFun == false) {
      return false;
    } else {
      const reqUrl = `calculate/getmaturitydate`;
      const response = await sendRequest(reqUrl, {
        id: appId,
        data: formJson,
      });
      if (response && response.status == "200") {
        setMaturityDate(
          dayjs(response.data.maturity_date).format("YYYY-MM-DD")
        );
        setPaymentCount(response.data.payment_count);

        setIsSubmit(true);
      } else {
        errorNotify("Error in calculating maturity date");
      }
    }
  };

  function toDecimal(arg0: number, arg1: number): any {
    let num = Number(arg0);
    return num.toFixed(arg1);
  }

  return (
    <React.Fragment>
      <Button
        id="btn-application-approved"
        label={btnName}
        variant="contained"
        size="medium"
        color="success"
        sx={{
          marginLeft: "10px",
          width:
            btnName == "Approved" || btnName == "Approve" ? "120px" : "160px",
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id={`dialog-application-approved-${appId}`}
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();

            const interest_rate = interestRate;
            if (
              interest_rate === "" ||
              interest_rate == null ||
              interest_rate == undefined
            ) {
              setCheckCal(false);
              setInterestRateError(true);
            } else {
              setInterestRateError(false);
            }
            if (terms == "" || terms == null || terms == undefined) {
              setCheckCal(false);
              setTermsError(true);
            } else {
              setTermsError(false);
            }
            const note_date = noteDate;
            if (
              note_date == "" ||
              note_date == null ||
              note_date == undefined ||
              note_date == "YYYY-MM-DD"
            ) {
              setCheckCal(false);
              setNoteDateError(true);
            } else {
              setNoteDateError(false);
            }
            const first_payment_date = firstPaymentDate;
            if (
              first_payment_date == "" ||
              first_payment_date == null ||
              first_payment_date == undefined ||
              first_payment_date == "YYYY-MM-DD"
            ) {
              setCheckCal(false);
              setFirstPaymentDateError(true);
            } else {
              setFirstPaymentDateError(false);
            }

            const payment_frequency = (
              document.getElementsByName(
                "payment_frequency"
              )[0] as HTMLInputElement
            ).value;
            if (
              payment_frequency == "" ||
              payment_frequency == null ||
              payment_frequency == undefined
            ) {
              document.getElementsByName(
                "payment_frequency"
              )[0].style.backgroundColor = "#fffac7";
              setCheckCal(false);
            }

            const number_payments = (
              document.getElementsByName(
                "number_payments"
              )[0] as HTMLInputElement
            ).value;

            const maturity_date = (
              document.getElementsByName("maturity_date")[0] as HTMLInputElement
            ).value;

            const notes = (
              document.getElementsByName("notes")[0] as HTMLInputElement
            ).value;

            const formJson: {
              amount: any;
              note_date: string;
              term: string;
              iterm: string;
              payment_frequency: string;
              rate: string;
              first_payment_date: string;
              payment_number?: string;
              maturity_date?: string;
              notes?: string;
              comment?: string;
              latefee?: number;
              graceperiod?: number;
              loanamount?: any;
              option?: string;
            } = {
              amount: loanAmount || record.amountSubmit,
              note_date: note_date,
              iterm: terms.toString(),
              term: terms.toString(),
              payment_frequency: payment_frequency,
              rate: interest_rate,
              first_payment_date: first_payment_date,
            };

            if (dayjs(first_payment_date).isBefore(dayjs(), "day")) {
              errorNotify("First Payment Date must be greater than today");
              return false;
            }
            if (dayjs(first_payment_date).isBefore(dayjs(note_date), "day")) {
              errorNotify("First Payment Date must be greater than Note Date");
              return false;
            }
            if (
              formJson.note_date == "" ||
              formJson.term == "" ||
              formJson.payment_frequency == "" ||
              formJson.rate == "" ||
              formJson.first_payment_date == ""
            ) {
              errorNotify("Please fill all required fields");
              return false;
            }

            const reqUrl = `calculate/getmaturitydate`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (response && response.status == "200") {
              setMaturityDate(
                dayjs(response.data.maturity_date).format("YYYY-MM-DD")
              );
              setPaymentCount(response.data.payment_count);
              setIsSubmit(true);

              formJson["payment_number"] = number_payments;
              formJson["maturity_date"] = maturity_date;
              formJson["notes"] = notes;
              formJson["comment"] = notes;
              formJson["loanamount"] = loanAmount || record.amountSubmit;
              let max_latefee = record.lateFeeData.reduce(function (
                prev: any,
                current: any
              ) {
                return prev.lateFee > current.lateFee ? prev : current;
              });
              let adjust_latefee = record.lateFeeAdjust;
              let max_grace_period = record.gracePeriodData.reduce(function (
                prev: any,
                current: any
              ) {
                return prev.gracePeriod > current.gracePeriod ? prev : current;
              });

              let adjust_grace_period = record.gracePeriodAdjust;
              let latefee = max_latefee;
              let graceperiod = max_grace_period;

              if (
                payment_frequency == "Monthly" ||
                payment_frequency == "Month End Payment" ||
                payment_frequency == "Single Repayment"
              ) {
                latefee = max_latefee;
                graceperiod = 16;
              } else if (payment_frequency == "Semimonthly") {
                latefee = toDecimal(max_latefee / 2, 2);
                graceperiod = 8;
              } else if (payment_frequency == "Weekly") {
                latefee = toDecimal(max_latefee / 4, 2);
                graceperiod = 6;
              } else if (payment_frequency == "Bi-Weekly") {
                latefee = toDecimal(max_latefee / 2, 2);
                graceperiod = 8;
              }

              if (adjust_latefee == "No" || adjust_latefee == "") {
                latefee = max_latefee;
              }
              if (adjust_grace_period == "No" || adjust_grace_period == "") {
                graceperiod = max_grace_period;
              }

              formJson["latefee"] = latefee;
              formJson["graceperiod"] = graceperiod;
              formJson["option"] = btnName == "" ? "approve" : btnName;

              const reqUrl = `applications/actions/recommend/approve`;
              const responseBack = await sendRequest(reqUrl, {
                id: appId,
                data: formJson,
              });
              if (responseBack && responseBack.status == "200") {
                successNotify("Data saved successfully");
                if (props.cb) {
                  props.cb("To Notify");
                }
                handleClose();
              } else {
                errorNotify(responseBack?.message || "Data not saved!");
              }
            } else {
              errorNotify("Error in calculating maturity date");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle={btnName} />
        </DialogTitle>
        <DialogContent>
          <Box sx={{ height: "500px", minHeight: "300px" }}>
            <DialogContentText></DialogContentText>
            <DialogApplicationBaseInfo appId={appId} record={record} />
            <Grid container sx={{ mb: 2, pb: 2 }}>
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Recommended Terms
                </Typography>
              </Grid>
              {record.sSubType == "account" && <>need add Account Term Data</>}
              {record.sSubType != "account" && (
                <>
                  {/* add loanamount field */}
                  {/* loan amount */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Loan Amount" required />
                    </Grid>

                    <Grid item xs={5}>
                      <CustomControlMoneyEditTextField
                        name="loanamount"
                        defaultValue={loanAmount}
                        min={record?.minAmountData}
                        max={record?.maxAmountData}
                        readonly={true}
                        onChange={handleInputChange}
                        required={true}
                        prefix={false}
                        helperText="no"
                        className="amountText"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                  {/* Rate */}
                  {showTermData.includes("rate") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Interest Rate"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          variant="outlined"
                          id="rate"
                          name="rate"
                          optionlist={defautRateOptionList}
                          value={interestRate}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const nextValue = normalizeRateValue(
                              e.target.value
                            );
                            if (nextValue !== "") {
                              setInterestRate(nextValue);
                              setInterestRateError(false);
                            } else {
                              setInterestRate("");
                              setInterestRateError(true);
                            }
                          }}
                          className="numericText"
                          error={interestRateError}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                  {showTermData.includes("term") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Term (Months)"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          variant="outlined"
                          id="term"
                          name="term"
                          optionlist={defautTermsList}
                          value={terms}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != "") {
                              setTerms(e.target.value);
                              setTermsError(false);
                            } else {
                              setTerms("");
                              setTermsError(true);
                            }
                          }}
                          className="numericText"
                          error={termsError}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                  {record.sPaymentMethod ==
                    "Interest Only and P&I during the Term" &&
                    showTermData.includes("payment_method") && (
                      <Grid sx={{ mb: 2 }} container>
                        <Grid item xs={5} sx={{ pt: 1 }}>
                          <HeaderLabelTitle
                            title="Term (Months)"
                            required={true}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <PaymentMethodField />
                        </Grid>
                        <Grid item xs={2}></Grid>
                      </Grid>
                    )}
                  {showTermData.includes("note_date") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Note Date (Funding Date)"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomDateTextInput
                          id="note_date"
                          name="note_date"
                          value={noteDate}
                          onChange={(value: string) => {
                            if (value != "") {
                              setNoteDate(value);
                              setNoteDateError(false);
                            } else {
                              setNoteDate("");
                              setNoteDateError(true);
                            }
                          }}
                          error={noteDateError}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                  {showTermData.includes("first_payment_date") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="First Payment Date"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomDateTextInput
                          id="first_payment_date"
                          name="first_payment_date"
                          value={firstPaymentDate}
                          onChange={(value: string) => {
                            if (value != "") {
                              setFirstPaymentDate(value);
                              setFirstPaymentDateError(false);
                            } else {
                              setFirstPaymentDate("");
                              setFirstPaymentDateError(true);
                            }
                          }}
                          error={firstPaymentDateError}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                  {showTermData.includes("payment_frequency") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Payment Frequency"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          variant="outlined"
                          id="payment_frequency"
                          name="payment_frequency"
                          value={paymentFrequency}
                          optionlist={defautPaymentFreqList}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != "") {
                              setPaymentFrequency(e.target.value);
                              setPaymentFrequencyError(false);
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                  {showTermData.includes("number_payments") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          fullWidth
                          title="Number Of Payments"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          id="number_payments"
                          name="number_payments"
                          value={paymentCount}
                          InputProps={{ readOnly: true }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                          }}
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                  {showTermData.includes("maturity_date") && (
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Maturity Date"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          id="maturity_date"
                          name="maturity_date"
                          value={maturityDate}
                          InputProps={{ readOnly: true }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                          }}
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                </>
              )}

              <Grid sx={{ mb: 2 }} container>
                <HeaderLabelTitle title="Add Note (Max 150 Characters)" />
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <TextField
                  id="notes"
                  name="notes"
                  placeholder="Notes"
                  multiline={true}
                  minRows={1}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {/* <CustomButtonSubmit label="Approve" color="success" /> */}
          <CustomButtonSubmit
            label={btnName}
            color="success"
            sx={{ minWidth: "120px", width: "auto" }}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
